export class WebhookV1GdsgOperationalNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "environmentId",
            "baseName": "environmentId",
            "type": "string",
            "format": ""
        },
        {
            "name": "environmentName",
            "baseName": "environmentName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "stage",
            "baseName": "stage",
            "type": "string",
            "format": ""
        },
        {
            "name": "signal",
            "baseName": "signal",
            "type": "string",
            "format": ""
        },
        {
            "name": "currentValueMs",
            "baseName": "currentValueMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "slaSeconds",
            "baseName": "slaSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lastReportTime",
            "baseName": "lastReportTime",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "reportIntervalMs",
            "baseName": "reportIntervalMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sampleError",
            "baseName": "sampleError",
            "type": "string",
            "format": ""
        },
        {
            "name": "consoleLink",
            "baseName": "consoleLink",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1GdsgOperationalNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
